import { serviceAgreementApi } from 'api';
import { CreateServiceAgreementRequest, ServiceDefinitionNode } from 'pco-product-service-internal-consumer';

export const createServiceAgreementApi = async (
  partnerUid: string | undefined,
  businessRelationUid: string | undefined,
  serviceDefinitionInput: string | ServiceDefinitionNode,
  contactNoteUids?: string[],
) => {
  //Normalize the input: If it's a string, turn it into the expected Node object
  const serviceDefinition: ServiceDefinitionNode =
    typeof serviceDefinitionInput === 'string'
      ? { serviceDefinitionId: serviceDefinitionInput, children: [] }
      : serviceDefinitionInput;

  const createServiceAgreementRequest: CreateServiceAgreementRequest = {
    serviceDefinition,
    ...(contactNoteUids?.length ? { contactNoteUids } : {}),
  };

  return await serviceAgreementApi.createServiceAgreement({
    createServiceAgreementRequest,
    businessRelationUid,
    partnerUid,
  });
};
